import React from 'react';

// Components
import Avatar from '@/views/components/avatar/Avatar';
import { Tooltip } from '@/views/components/tooltips';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';

// Legacy Component
import LegacyContactPastille from './LegacyContactPastille';

// Types
import GenericContact from '@/types/generic-contact';
import AdvisorInfos from '@/types/advisor-infos';
import ComparisonContact from '@/types/comparison-contact';

// Utils
import { getContactInitials, getContactName } from '@/utils/contacts';

interface Props {
  contact: GenericContact | AdvisorInfos | ComparisonContact;
  backgroundColor?: string;
  borderColor?: string;
  tooltip?: boolean;
}

const ContactPastilleV2 = ({ contact, tooltip }: Props) => {
  const initials = getContactInitials(contact);

  const avatar = (
    <div className="contact-pastille contact-pastille-v2">
      <Avatar>{initials}</Avatar>
    </div>
  );

  if (tooltip) {
    const fullname = getContactName(contact);
    return (
      <Tooltip className="custom-tooltip-v2" message={fullname} place="top">
        {avatar}
      </Tooltip>
    );
  }

  return avatar;
};

const ContactPastille = ({ contact, backgroundColor, borderColor, tooltip }: Props) => {
  const { isLightVersion } = useThemeVersion();
  return isLightVersion ? (
    <ContactPastilleV2 contact={contact} tooltip={tooltip} />
  ) : (
    <LegacyContactPastille contact={contact} backgroundColor={backgroundColor} borderColor={borderColor} />
  );
};

export default ContactPastille;
